import { cva } from '@zenchef/styled-system/css'

export const telInputRecipe = cva({
  base: {
    '& .iti': {
      display: 'block',
      borderRadius: 'l',
      height: '[35px]',
      borderColor: '[#d5d6d7]',
      borderWidth: 'm'
    },

    // country selector button and its wrapper
    '& .iti__country-container, & .iti__selected-country': {
      height: '100%',
      padding: '[0px]'
    },

    // Dropdown content start
    '& .iti__dropdown-content:not(.iti__hide)': {
      display: 'flex',
      flexDirection: 'column',
      pb: 'padding.3',
      bgColor: 'background.neutral.base.subtlest',
      borderRadius: 'l',
      gap: 'gap.6',
      boxShadow: 'effect.shadow.subtle-bottom'
    },

    '& .iti__search-input': {
      width: 'auto',
      height: 'xl',
      mx: 'padding.3',
      mt: 'padding.3',
      borderRadius: 'm',
      borderWidth: 'm',
      borderColor: 'border.neutral.bold',
      textStyle: 'paragraph.m.regular',
      color: 'content.neutral.base.bold',
      px: 'padding.3',

      _focusVisible: {
        borderColor: 'border.brand-bold',
        outline: 'none'
      }
    },

    '& .iti__country-list': {
      px: 'padding.3'
    },

    '& .iti__country': {
      height: 'xl',
      px: 'padding.3',
      borderRadius: 'l',
      gap: 'gap.2',

      '&:not(:last-child)': {
        marginBottom: 'padding.1'
      }
    },

    '& .iti__country-name': {
      textStyle: 'paragraph.m.bold',
      color: 'content.neutral.base.bold'
    },

    '& .iti__flag': {
      transform: 'scale(1.25)',
      mx: 'padding.0,5'
    },

    '& .iti__flag, & .iti__country-name': {
      margin: 'unset'
    },
    // Dropdown content end

    '& .iti__tel-input': {
      height: '100%',
      paddingLeft: '67px !important',
      fontSize: '0.92em',
      border: 'none',
      width: '100% !important',
      color: '[#59565f]',

      _focusVisible: {
        outline: 'none'
      },

      _placeholder: {
        color: '[#cdced1]'
      }
    },

    '& .iti__arrow': {
      border: 'none',
      fontSize: '[18px]',
      height: '[18px]',
      width: '[18px]',
      lineHeight: 1,

      _before: {
        fontFamily: 'aromaticons',
        content: `"\\e97f"`,
        color: 'grey',
        display: 'inline-block'
      }
    },

    '& .iti__selected-country': {
      backgroundColor: '[#f7f7f7]',
      borderRightColor: '[#d5d6d7]',
      paddingLeft: 'padding.2',
      borderRadius: '{sizes.4xs} 0 0 {sizes.4xs}',
      width: '[55px]',
      outline: 'none',
      borderRight: '{borderWidths.m} solid #d5d6d7'
    },

    '& .iti__selected-country-primary': {
      padding: '[0px]',
      backgroundColor: 'unset',

      _hover: {
        backgroundColor: 'unset'
      }
    },

    '@media (max-width: 499px)': {
      '& .iti__tel-input': {
        fontSize: '1em'
      },
      '& .iti': {
        height: '[45px]'
      }
    }
  },

  variants: {
    error: {
      true: {
        '& .iti': {
          borderColor: '[#eb5160]'
        }
      }
    },
    mini: {
      true: {
        '& .iti': {
          height: '[30px]'
        }
      }
    }
  }
})
